import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import PaymentVerification from "../components/PaymentVerification";
import { CartProvider } from "../../cart/context/CartContext";

const PaymentVerificationPage = () => {
  return (
    <CartProvider>
      <ColorInit color={"bigmall"} />
      <ScrollToTop smooth color="#ef253c" />
      <Header />
      <PaymentVerification />
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default PaymentVerificationPage;